module.exports = __webpack_public_path__ + "img/AI-icon.0f55603a.svg";